/* Nividas PDP colorway strip — May 2026, reworked 2026-10-21.
   Desktop: click-and-drag to scroll, arrows (as the photo gallery's), and
            the selected colour centred.
   Mobile:  native touch scrolling owns the gesture entirely; this script
            doesn't touch touch events. */

(function () {
  'use strict';

  // Centering math uses getBoundingClientRect, not offsetLeft, because the
  // strip is `position: static` and offsetLeft would be relative to <body>
  // (or some other ancestor), not the strip — which silently produced a
  // wrong target every time. Rects are viewport-relative and don't care
  // about the offsetParent chain. Always instant: the selected colour should
  // simply be in the middle when the page appears, not slide there.
  function centerActive(strip) {
    const active = strip.querySelector('.nv-pdp-colorway__item.is-active');
    if (!active || active.getBoundingClientRect().width === 0) return;
    const stripRect = strip.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const delta = (activeRect.left + activeRect.width / 2) - (stripRect.left + stripRect.width / 2);
    const max = strip.scrollWidth - strip.clientWidth;
    const target = Math.max(0, Math.min(max, strip.scrollLeft + delta));
    const saved = strip.style.scrollBehavior;
    strip.style.scrollBehavior = 'auto';
    strip.scrollLeft = target;
    strip.style.scrollBehavior = saved;
  }

  function init(strip) {
    if (!strip || strip.dataset.nvBound === '1') return;
    strip.dataset.nvBound = '1';
    const viewport = strip.closest('.nv-pdp-colorway__viewport') || strip.parentElement;
    const prev = viewport.querySelector('[data-nv-pdp-colorway-prev]');
    const next = viewport.querySelector('[data-nv-pdp-colorway-next]');

    // Once the customer has scrolled the strip themselves, never move it for
    // them again (re-centring would undo what they just did).
    let userMoved = false;

    function updateArrows() {
      const max = strip.scrollWidth - strip.clientWidth;
      if (prev) prev.disabled = strip.scrollLeft <= 1;
      if (next) next.disabled = strip.scrollLeft >= max - 1;
    }

    let queued = false;
    function settle() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (!userMoved) centerActive(strip);
        updateArrows();
      });
    }

    /* Why centring used to miss (Jakob 2026-10-21): it ran once at load,
       but on a prescription page the colours that aren't prescription-
       available are hidden a moment later (data-lens-state), and images and
       fonts settle after that. Each of those shifts the row. So centre again
       whenever the row's contents or size change, until the customer moves
       it themselves. */
    if (window.MutationObserver) {
      // Not 'style': centerActive sets the strip's own style, which would loop
      new MutationObserver(settle).observe(strip, { subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    }
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(settle);
      ro.observe(strip);
      strip.querySelectorAll('.nv-pdp-colorway__item').forEach(function (it) { ro.observe(it); });
    }
    strip.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) { img.addEventListener('load', settle, { once: true }); img.addEventListener('error', settle, { once: true }); }
    });
    window.addEventListener('load', settle, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);

    strip.addEventListener('scroll', updateArrows, { passive: true });
    strip.addEventListener('wheel', function () { userMoved = true; }, { passive: true });
    strip.addEventListener('touchstart', function () { userMoved = true; }, { passive: true });
    strip.addEventListener('keydown', function () { userMoved = true; });

    // Arrows: move about two-thirds of the visible row, like paging photos
    function page(dir) {
      userMoved = true;
      strip.scrollBy({ left: dir * Math.max(120, strip.clientWidth * 0.66), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    // Desktop click-and-drag to scroll. Mouse events only — they don't fire
    // for touch input, so this can't interfere with native mobile scrolling.
    // Document-level move/up listeners are attached on demand so the drag
    // survives the cursor leaving the strip bounds.
    let startX = 0;
    let startScroll = 0;
    let moved = 0;
    let savedScrollBehavior = '';

    function onMove(e) {
      const dx = e.pageX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) {
        // Prevent text selection / image drag while panning.
        e.preventDefault();
        userMoved = true;
        strip.scrollLeft = startScroll - dx;
      }
    }

    function onUp() {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      strip.style.scrollBehavior = savedScrollBehavior;
    }

    strip.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      startX = e.pageX;
      startScroll = strip.scrollLeft;
      moved = 0;
      // CSS sets `scroll-behavior: smooth` on the strip, which would
      // animate every scrollLeft mutation during drag and produce a
      // laggy, "rubbery" feel. Force instant scroll for the drag, then
      // restore on mouseup.
      savedScrollBehavior = strip.style.scrollBehavior;
      strip.style.scrollBehavior = 'auto';
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });

    // Suppress click if the user dragged past the threshold, so they
    // don't accidentally navigate to a sibling product after panning.
    strip.addEventListener('click', function (e) {
      if (moved > 6) {
        e.preventDefault();
        e.stopPropagation();
        moved = 0;
      }
    }, true);

    // Block native HTML5 image drag — without this, mousedown on a
    // swatch <img> can start a "drag image to desktop" gesture that
    // hijacks our scroll-drag mid-motion.
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });

    centerActive(strip);
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-nv-pdp-colorway]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
